import multireducer from 'multireducer';
import knsearch from './knsearch';
import { sources } from '../utils/knreise';
var searchSources = {};
export default function () {
  sources.forEach(function (source) {
    searchSources[source.dataIndex] = knsearch;
  });
  return multireducer(searchSources);
}